import { applicationVersionList, statusList } from './request';
import { applicationResource } from './../applicationManage/request';
import addVersionModel from './addVersionModel.vue';
import seeVersionModel from './seeVersionModel.vue';
export default {
  components: {
    addVersionModel,
    seeVersionModel
  },
  data() {
    return {
      addVersionShow: false,
      seeVersionShow: false,
      statusList: statusList,
      applicationList: [],
      form: {
        versionNumber: '',
        createAt: '',
        status: undefined,
        applicationId: undefined
      },
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      data: [],
      columns: [{
        slots: {
          title: '序号'
        },
        dataIndex: 'index',
        key: '1',
        align: 'center',
        scopedSlots: {
          customRender: 'index'
        },
        width: 80
      }, {
        slots: {
          title: '发布应用'
        },
        dataIndex: 'applicationName',
        key: '2',
        align: 'center'
      }, {
        slots: {
          title: '版本号'
        },
        dataIndex: 'versionNumber',
        key: '3',
        align: 'center'
      }, {
        slots: {
          title: '上线平台'
        },
        dataIndex: 'platform',
        key: '4',
        align: 'center'
      }, {
        slots: {
          title: '申请人'
        },
        dataIndex: 'userName',
        key: '5',
        align: 'center'
      }, {
        slots: {
          title: '申请时间'
        },
        dataIndex: 'createAt',
        key: '6',
        align: 'center'
      }, {
        slots: {
          title: '审核结果'
        },
        dataIndex: 'status',
        key: '7',
        align: 'center',
        scopedSlots: {
          customRender: 'customText'
        }
      }, {
        slots: {
          title: '操作'
        },
        scopedSlots: {
          customRender: 'action'
        },
        align: 'center',
        key: '8',
        align: 'center',
        width: 100
      }]
    };
  },
  created() {
    this.getDataFun();
    applicationResource({}).then(res => {
      console.log(res, 5555);
      this.applicationList = res;
    });
  },
  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    searchFun() {
      this.pagination.current = 1;
      this.getDataFun();
    },
    getDataFun() {
      let obj = this.form;
      obj.page = this.pagination.current;
      obj.pageSize = this.pagination.pageSize;
      applicationVersionList(obj).then(res => {
        this.data = res.items;
        this.pagination.total = res.totalNum;
      });
    },
    handleAdd() {
      this.addVersionShow = true;
      this.$nextTick(() => {
        this.$refs.addVersionFrom.init();
      });
    },
    handleSee(val) {
      this.seeVersionShow = true;
      this.$nextTick(() => {
        this.$refs.seeVersionFrom.init(val);
      });
    }
  }
};